import styles from "./About.module.css";
import { about } from "../../data/about";
import { companies } from "../../data/companies";

const industries = Array.from(new Set(companies.map((c) => c.industry))).length;

export default function About() {
  return (
    <section id="about" className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <p className={styles.label}>About</p>
          <h2 className={styles.name}>{about.name}</h2>
          <p className={styles.title}>{about.title}</p>
          <p className={styles.bio}>{about.bio}</p>
          <div className={styles.actions}>
            <a href={`mailto:${about.email}`} className={styles.emailBtn}>
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              Email me
            </a>
            {about.linkedin && (
              <a
                href={about.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.linkedinBtn}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
                LinkedIn
              </a>
            )}
          </div>
        </div>

        <div className={styles.right}>
          <div className={styles.photoCard}>
            <div className={styles.photoWrapper}>
              <img
                src={process.env.PUBLIC_URL + "/Uncle%20Yasser%20Home.jpeg"}
                alt={about.name}
                className={styles.photo}
              />
              <div className={styles.photoOverlay}>
                <span className={styles.overlayName}>{about.name}</span>
                <span className={styles.overlayTitle}>{about.title}</span>
              </div>
            </div>
            <div className={styles.cardStats}>
              <div className={styles.cardStat}>
                <span className={styles.cardStatNum}>{companies.length}</span>
                <span className={styles.cardStatLabel}>Companies</span>
              </div>
              <div className={styles.cardStatDivider} />
              <div className={styles.cardStat}>
                <span className={styles.cardStatNum}>{industries}</span>
                <span className={styles.cardStatLabel}>Industries</span>
              </div>
              <div className={styles.cardStatDivider} />
              <div className={styles.cardStat}>
                <span className={styles.cardStatNum}>30+</span>
                <span className={styles.cardStatLabel}>Years</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
